// This is only used for new activities done with the new microservices architecture.
// For activities and slides that are in content tool go to slideTypes enum.
export default {
	NONE_QUESTION: 0,
	OPEN_ENDED_QUESTION: 1,
	POLL_QUESTION: 2,
	MULTIPLE_CHOICE_QUESTION: 3,
	ACTIVITY: 98,
	MEDIA: 99,
}
